import { render, staticRenderFns } from "./SlideFeed.vue?vue&type=template&id=01fd5a5c&scoped=true&"
import script from "./SlideFeed.vue?vue&type=script&lang=js&"
export * from "./SlideFeed.vue?vue&type=script&lang=js&"
import style0 from "./SlideFeed.vue?vue&type=style&index=0&id=01fd5a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd5a5c",
  null
  
)

export default component.exports